interface Step1AuthProps {
  onNext: (data: {
    method: "search_console" | "manual";
    domain?: string;
    brandName?: string;
  }) => void;
  onLogin: () => void;
}

export function Authentication({ onNext, onLogin }: Step1AuthProps) {
  const handleSearchConsole = () => {
    onLogin(); // Trigger auth flow - OnboardingFlow will handle advancing to Step 2 after auth
  };

  const handleManual = () => {
    onNext({ method: "manual" });
  };

  return (
    <div className="w-full max-w-md mx-auto space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <div className="space-y-2 pb-6">
        <h1 className="text-xl font-semibold tracking-tight text-slate-900">
          Prompt Generator
        </h1>
        <p className="text-gray-500 text-sm">
          Use Search Console or a domain to monitor your brand presence across relevant LLM search results.
        </p>
      </div>
      {/* Primary Button - Connect Search Console */}
      <button
        onClick={handleSearchConsole}
        className="group w-full relative flex items-center justify-center gap-3 rounded-md bg-blue-600 px-4 py-4 text-sm font-semibold text-white shadow-sm transition-all hover:bg-blue-700 hover:shadow-md"
      >
        <svg
          className="h-5 w-5"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
        </svg>
        <span>Connect Google Search Console</span>
      </button>
      <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t border-slate-200" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-slate-50 px-2 text-slate-500">
              Or
            </span>
          </div>
        </div>
      {/* Secondary Button - Enter Manually */}
      <button
        onClick={handleManual}
        className="group w-full relative flex items-center justify-center gap-3 rounded-md bg-white px-6 py-4 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 transition-all hover:bg-slate-50 hover:ring-slate-300"
      >
        <svg
          className="h-5 w-5 text-slate-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
        <span>Enter Domain Manually</span>
      </button>
    </div>
  );
}
